import DesktopLayout from '../../layouts/DesktopLayout';
import InitContent from '../shared/InitContent';

export default function DesktopAuthPage() {
  return (
    <DesktopLayout>
      <InitContent />
    </DesktopLayout>
  );
}
